// extracted by mini-css-extract-plugin
export default {"List__alternateBullet":"List__alternateBullet_I7pto"};